export const editAccountsUserSchema = [
  [
    {
      title: 'Name',
      id: 'name',
      type: 'text',
      required: true,
    },
    {
      title: 'Email Id',
      id: 'emailId',
      type: 'email',
      required: true,
    },
    {
      title: 'Update user',
      type: 'button',
      width: '30%',
    },
  ],
];

export const editBrandManagerUserSchema = [
  [
    {
      title: 'Name',
      id: 'name',
      type: 'text',
      required: true,
    },
    {
      title: 'Email Id',
      id: 'emailId',
      type: 'email',
      required: true,
    },
    {
      title: 'Brand',
      id: 'company',
      type: 'dropdownCheck',
      isMultiSelect: true,
      options: [],
      required: true,
      placeholder: 'Select Brand/Brand',
    },
    {
      title: 'Category',
      id: 'category',
      type: 'dropdownCheck',
      isMultiSelect: true,
      options: [],
      required: true,
      placeholder: 'Select Category/Categories',
    },
    {
      title: 'Update user',
      type: 'button',
      width: '30%',
    },
  ],
];

export const editVendorUserSchema = [
  [
    {
      title: 'Name',
      id: 'name',
      type: 'text',
      required: true,
    },
    {
      title: 'Email Id',
      id: 'emailId',
      type: 'email',
      required: true,
    },
    {
      title: 'Brand',
      id: 'company',
      type: 'dropdownCheck',
      options: [],
      required: true,
      placeholder: 'Select Brand',
    },
    {
      title: 'Category',
      id: 'category',
      type: 'dropdownCheck',
      isMultiSelect: true,
      options: [],
      required: true,
      placeholder: 'Select Category/Categories',
    },
    {
      title: 'Update user',
      type: 'button',
      width: '30%',
    },
  ],
];
